var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_47439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0506 18.0878C21.2544 18.0878 17.3671 21.9751 17.3671 26.7713C17.3671 31.5676 21.2544 35.4549 26.0506 35.4549C30.8468 35.4549 34.7342 31.5676 34.7342 26.7713C34.7342 21.9751 30.8468 18.0878 26.0506 18.0878ZM26.9465 30.265C26.3994 30.8121 25.6729 31.1131 24.9001 31.1131H24.8972C24.1243 31.1131 23.3978 30.8106 22.8522 30.2636L19.9403 27.3517L21.9867 25.3053L24.9001 28.2186L30.1319 22.9868L32.1783 25.0332L26.9465 30.265ZM31.5531 0.720703L34.7342 10.1279V10.8515C34.7342 14.0442 32.1378 16.6405 28.9452 16.6405H27.4979C25.7713 16.6405 24.217 15.8807 23.1561 14.6766C22.0953 15.8807 20.5409 16.6405 18.8143 16.6405H15.9198C14.1831 16.6405 12.6403 15.8561 11.5781 14.6404C10.5158 15.8561 8.973 16.6405 7.23629 16.6405H5.78903C2.59638 16.6405 0 14.0442 0 10.8515L0.0347342 9.81382L3.18107 0.720703H10.1308V7.95699H13.0253V0.720703H21.7089V7.95699H24.6034V0.720703H31.5531ZM18.4178 35.4549H5.78903C3.39527 35.4549 1.44726 33.5069 1.44726 31.1131V18.3584C2.72663 19.1023 4.20718 19.5351 5.78903 19.5351H7.23629C8.77328 19.5351 10.2683 19.1182 11.5781 18.3512C12.8878 19.1182 14.3843 19.5351 15.9198 19.5351H17.027C15.4321 21.5192 14.4726 24.0346 14.4726 26.7713C14.4726 30.2303 16.0052 33.3318 18.4178 35.4549Z",
    fill: "#C8685A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_47439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7342,
    height: 34.7342,
    fill: "white",
    transform: "translate(0 0.720703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOrder);
export default __webpack_public_path__ + "static/media/place-order.8ecb42c258aa466dc7d6d807745e12f2.svg";
export { ForwardRef as ReactComponent };